import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/_services/auth.service';
import { SettingsService } from 'src/app/_services/settings.service';
import { NotificationService } from 'src/app/_services/core/notification.service';
import * as QRCode from 'qrcode';

@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.scss']
})
export class OtpComponent implements OnInit {

  assetUrl = environment.assetUrl;
  form!: FormGroup;
  isLoading = false;
  year = new Date().getFullYear();
  siteSettings: any = {};

  qrCodeImage: string = '';
  manualCode: string = '';
  isSetupLoading = true;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private notify: NotificationService,
    private settingsService: SettingsService,
  ) { }

  ngOnInit(): void {
    this.inItForm();
    this.load2FASetup();
    this.settingsService.getSiteSettings().subscribe((res: any) => {
      this.siteSettings = res.message;
    });
  }

  inItForm = (): void => {
    this.form = this.fb.group({
      code: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(6)]],
      secret: [''],
    });
  }

  load2FASetup = (): void => {
    this.authService.setup2FA().subscribe(
      async (res) => {
        if (res.status) {
          const otpAuthUrl = `otpauth://totp/${encodeURIComponent('Admin-' + res?.getProfileDetails?.email)}?secret=${res?.getProfileDetails?.secretKey}&issuer=${encodeURIComponent(this.siteSettings?.siteName || 'Crypto Exchange')}`;
          this.manualCode = res?.getProfileDetails?.secretKey;
          this.form.patchValue({
            secret: res?.getProfileDetails?.secretKey
          });
          const qrCodeUrl = await QRCode.toDataURL(otpAuthUrl);
          this.qrCodeImage = qrCodeUrl;
        } else {
          this.notify.showError('Failed to generate 2FA setup.');
        }
        this.isSetupLoading = false;
      },
      (err) => {
        this.notify.showSystemError(err);
        this.isSetupLoading = false;
      }
    );
  }

  copyCode(): void {
    navigator.clipboard.writeText(this.manualCode);
    this.notify.showSuccess('Security Key Copied');
  }
  logout(): void {
    this.authService.logout().subscribe((resData) => {
      if (resData) {
        this.router.navigate(['login']);
      }
    });
  }
  formSubmitHandler = (): void => {
    if (this.form.invalid) return;

    this.isLoading = true;

    this.authService.verify2FA(this.form.value).subscribe(
      (res) => {
        if (res.status) {
          this.notify.showSuccess('2FA Enabled Successfully');
          this.logout();
        } else {
          this.notify.showError('Invalid 2FA Code');
        }
        this.isLoading = false;
      },
      (err) => {
        this.notify.showSystemError(err);
        this.isLoading = false;
      }
    );
  }

}